<template>
  <!-- Редактирование модификатора -->
  <div v-if="logItem.action === 'edit'" class="menu-edit-log-item menu-edit-log-item_fullwidth">
    <before-after-log-item>
      <template v-slot:before>
        {{ menuItemName }}
        <span v-if="oldModificationName" class="menu-edit-log-item__mod">
          {{ oldModificationName }}
        </span>
        <span v-if="quantity" class="menu-edit-log-item__quantity">
          x{{ quantity }}
        </span>
      </template>
      <template v-slot:after>
        {{ menuItemName }}
        <span v-if="modificationName" class="menu-edit-log-item__mod">
          {{ modificationName }}
        </span>
        <span v-if="quantity" class="menu-edit-log-item__quantity">
          x{{ quantity }}
        </span>
      </template>
    </before-after-log-item>
  </div>

  <!-- Добавление блюда -->
  <div v-else-if="logItem.action === 'add'" class="menu-edit-log-item">
    <label-with-icon icon="plus">
      {{ menuItemName }}
      <span v-if="modificationName" class="menu-edit-log-item__mod">
        {{ modificationName }}
      </span>
      <span v-if="quantity" class="menu-edit-log-item__quantity">
        x{{ quantity }}
      </span>
    </label-with-icon>
  </div>

  <div v-else-if="logItem.action === 'delete'" class="menu-edit-log-item">
    <label-with-icon icon="minus">
      {{ menuItemName }}
      <span v-if="modificationName" class="menu-edit-log-item__mod">
        {{ modificationName }}
      </span>
      <span v-if="quantity" class="menu-edit-log-item__quantity">
        x{{ quantity }}
      </span>
    </label-with-icon>
  </div>
</template>

<script>
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'
  import LabelWithIcon
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/LabelWithIcon'
  export default {
    name: 'MenuEditLogItem',
    components: { LabelWithIcon, BeforeAfterLogItem },
    props: {
      logItem: Object,
    },
    computed: {
      menuItemName () {
        return this.logItem?.menuItem?.name || 'блюдо удалено из системы...'
      },
      isEditModification () {
        return this.logItem.modificationMenuItemId !== this.logItem.oldModificationMenuItemId
      },
      modificationName () {
        if (!this.logItem.modificationMenuItemId) {
          return null
        }
        return `(${this.logItem?.modificationMenuItem?.modification?.nameOn})`
      },
      oldModificationName () {
        if (!this.logItem.oldModificationMenuItemId) {
          return null
        }
        return `(${this.logItem?.oldModificationMenuItem?.modification?.nameOn})`
      },
      quantity () {
        return this.logItem.quantity > 1 ? this.logItem.quantity : 0
      },
    },
  }
</script>

<style lang="less" scoped>
.menu-edit-log-item {
  margin-right: 1.5em;
  margin-bottom: 1em;

  &_fullwidth {
    width: 100%;
    flex-basis: 100%;
  }

  &__mod {
    color: #6d6d6d;
    font-size: 0.85em;
    vertical-align: bottom;
  }

  &__quantity {
    margin-left: 2px;
    font-weight: 500;
    font-size: 1.1em;
  }
}
</style>
